/**
 * Help Center Articles Data
 *
 * User-facing help content for Hisab OK Hai.
 * NOT developer documentation.
 *
 * Structure:
 * - Categories define the main sections
 * - Each article has: slug, title, summary, content
 * - URLs: /help/:category/:slug
 */

export const HELP_CATEGORIES = [
  {
    id: 'getting-started',
    name: 'Shuru Kaise Karein',
    nameEn: 'Getting Started',
    description: 'App chalana seekhein - bilkul beginning se',
    icon: '🚀',
  },
  {
    id: 'ledgers',
    name: 'Khate (Ledgers)',
    nameEn: 'Ledgers',
    description: 'Apne alag-alag khate banayein aur manage karein',
    icon: '📒',
  },
  {
    id: 'transactions',
    name: 'Lena-Dena',
    nameEn: 'Transactions',
    description: 'Income, expense, udhari - sab kuch record karein',
    icon: '💸',
  },
  {
    id: 'vendors',
    name: 'Dukandaar / Vendors',
    nameEn: 'Vendors',
    description: 'Dukandaar ka hisab rakhein - kitna dena hai, kitna diya',
    icon: '🏪',
  },
  {
    id: 'budgets',
    name: 'Budget',
    nameEn: 'Budgets',
    description: 'Monthly budget set karein aur track karein',
    icon: '📊',
  },
  {
    id: 'reports',
    name: 'Reports',
    nameEn: 'Reports',
    description: 'Apna paisa kahaan gaya - reports mein dekhein',
    icon: '📈',
  },
  {
    id: 'security',
    name: 'Suraksha',
    nameEn: 'Security',
    description: 'Account safe rakhein - password, login tips',
    icon: '🔒',
  },
  {
    id: 'plans-and-billing',
    name: 'Plans & Payment',
    nameEn: 'Plans & Billing',
    description: 'Free vs Pro features, payment ka tarika',
    icon: '💳',
  },
];

/**
 * Articles organized by category
 * User-facing content in Hindi + easy English
 */
export const HELP_ARTICLES = {
  'getting-started': [
    {
      slug: 'app-kaise-shuru-karein',
      title: 'App Kaise Shuru Karein',
      summary: 'Hisab OK Hai app mein pehli baar kaise aayein',
      content: `
        <h2>Welcome to Hisab OK Hai!</h2>
        <p>Yeh app aapke paison ka hisab rakhne ke liye hai. Bilkul simple hai - koi mushkil nahi.</p>

        <h3>Step 1: Account Banayein</h3>
        <p>Sabse pehle aapko sign up karna hoga:</p>
        <ul>
          <li>App kholein</li>
          <li>"Sign Up" button dabayein</li>
          <li>Apna naam, email aur password daalein</li>
          <li>"Create Account" dabayein</li>
        </ul>
        <p><strong>Tip:</strong> Ek strong password choose karein jo aap yaad rakh sakein.</p>

        <h3>Step 2: Login Karein</h3>
        <p>Account banne ke baad:</p>
        <ul>
          <li>Apna email daalein</li>
          <li>Password daalein</li>
          <li>"Login" dabayein</li>
        </ul>
        <p>Bas! Ab aap app use kar sakte hain.</p>

        <h3>Aage Kya Karein?</h3>
        <p>Login ke baad aap Dashboard dekhenge. Wahan se aap:</p>
        <ul>
          <li>Apna pehla khata (ledger) bana sakte hain</li>
          <li>Income ya expense add kar sakte hain</li>
          <li>Apna paisa track kar sakte hain</li>
        </ul>
      `,
    },
    {
      slug: 'dashboard-samjhein',
      title: 'Dashboard Samjhein',
      summary: 'Dashboard pe kya kya dikhta hai aur kaise use karein',
      content: `
        <h2>Dashboard Kya Hai?</h2>
        <p>Dashboard aapka main screen hai. Yahan aap ek nazar mein dekh sakte hain ki aapke paas kitna paisa hai.</p>

        <h3>Dashboard Pe Kya Dikhta Hai</h3>

        <h4>1. Total Balance</h4>
        <p>Sabse upar aapka total paisa dikhta hai - sabhi khaton ka jod.</p>

        <h4>2. Aaj Ka Summary</h4>
        <p>Aaj kitna aaya, kitna gaya - ek nazar mein.</p>

        <h4>3. Recent Entries</h4>
        <p>Aapki last kuch entries dikhti hain - jaldi se check kar sakte hain ki sab sahi hai.</p>

        <h4>4. Quick Actions</h4>
        <p>Naya entry add karne ke liye "+" button use karein.</p>

        <h3>Tip</h3>
        <p>Roz ek baar dashboard check karein. Isse aapko pata rahega ki paisa kahaan ja raha hai.</p>
      `,
    },
    {
      slug: 'pehla-khata-banayein',
      title: 'Apna Pehla Khata Banayein',
      summary: 'Step by step guide - pehla ledger kaise banayein',
      content: `
        <h2>Khata Kya Hai?</h2>
        <p>Khata matlab ek jagah jahan aap paison ka hisab rakhte hain. Jaise:</p>
        <ul>
          <li><strong>Cash Khata</strong> - haath mein jo paisa hai</li>
          <li><strong>Bank Khata</strong> - bank mein jo paisa hai</li>
          <li><strong>Business Khata</strong> - dukaan ya kaam ka paisa</li>
        </ul>

        <h3>Pehla Khata Kaise Banayein</h3>

        <h4>Step 1</h4>
        <p>Menu mein "Ledgers" ya "Khate" pe click karein.</p>

        <h4>Step 2</h4>
        <p>"Add Ledger" ya "Naya Khata" button dabayein.</p>

        <h4>Step 3</h4>
        <p>Khate ka naam dein. Example: "Cash", "SBI Bank", "Business"</p>

        <h4>Step 4</h4>
        <p>Starting balance daalein - abhi is khate mein kitna paisa hai.</p>

        <h4>Step 5</h4>
        <p>"Save" karein. Bas ho gaya!</p>

        <h3>Suggestion</h3>
        <p>Shuru mein 2-3 khate kaafi hain. Baad mein aur bana sakte hain.</p>
      `,
    },
    {
      slug: 'navigation-guide',
      title: 'App Mein Kahaan Kya Hai',
      summary: 'Menu aur buttons ka guide',
      content: `
        <h2>App Mein Navigate Karna</h2>
        <p>Hisab OK Hai mein har cheez easily mil jaati hai. Yahan samjhein kahaan kya hai:</p>

        <h3>Bottom Menu (Mobile)</h3>
        <ul>
          <li><strong>Home</strong> - Dashboard pe jaayein</li>
          <li><strong>Transactions</strong> - Sabhi entries dekhein</li>
          <li><strong>+ Button</strong> - Naya entry add karein</li>
          <li><strong>Reports</strong> - Paisa kahaan gaya dekhein</li>
          <li><strong>Reminders</strong> - Yaad dilane wali cheezein</li>
        </ul>

        <h3>Settings Mein</h3>
        <p>Settings mein jaake aap:</p>
        <ul>
          <li>Categories manage kar sakte hain</li>
          <li>Profile update kar sakte hain</li>
          <li>Password change kar sakte hain</li>
          <li>Help Center (yeh page!) access kar sakte hain</li>
        </ul>

        <h3>Quick Tip</h3>
        <p>Kuch bhi add karna ho to "+" button sabse fast hai!</p>
      `,
    },
  ],
  'ledgers': [
    {
      slug: 'khata-kya-hota-hai',
      title: 'Khata (Ledger) Kya Hota Hai?',
      summary: 'Ledger ka matlab aur kyun use karein',
      content: `
        <h2>Simple Shabdon Mein</h2>
        <p>Khata ek diary jaisa hai jahan aap paison ka hisab likhte hain.</p>

        <p>Sochiye ki aapke paas:</p>
        <ul>
          <li>Ek notebook hai ghar ke kharche ke liye</li>
          <li>Ek notebook hai business ke liye</li>
          <li>Ek notebook hai bachhat ke liye</li>
        </ul>
        <p>Har notebook ek "Khata" hai.</p>

        <h3>Kyun Alag Khate Rakhein?</h3>
        <p>Alag khaton se:</p>
        <ul>
          <li>Pata rahega business ka paisa kahaan hai, ghar ka kahaan</li>
          <li>Bank balance alag, cash alag - sab clear</li>
          <li>Hisab mein gadbad nahi hogi</li>
        </ul>

        <h3>Common Khate</h3>
        <p>Log usually yeh khate banate hain:</p>
        <ul>
          <li><strong>Cash</strong> - jeb mein jo paisa hai</li>
          <li><strong>Bank Account</strong> - bank mein jo paisa hai</li>
          <li><strong>Credit Card</strong> - card pe jo kharcha hua</li>
          <li><strong>Business</strong> - kaam-dhandhe ka paisa</li>
          <li><strong>Savings</strong> - bachhat ka paisa</li>
        </ul>
      `,
    },
    {
      slug: 'naya-khata-kaise-banayein',
      title: 'Naya Khata Kaise Banayein',
      summary: 'Step by step - naya ledger add karna',
      content: `
        <h2>Naya Khata Add Karna</h2>

        <h3>Step 1: Ledgers Page Pe Jaayein</h3>
        <p>Menu mein "Ledgers" ya "Khate" pe click karein.</p>

        <h3>Step 2: Add Button Dabayein</h3>
        <p>"+ Add Ledger" ya "Naya Khata" button pe click karein.</p>

        <h3>Step 3: Details Bharein</h3>
        <ul>
          <li><strong>Name:</strong> Khate ka naam (jaise "SBI Bank", "Cash")</li>
          <li><strong>Opening Balance:</strong> Abhi is khate mein kitna paisa hai</li>
          <li><strong>Description:</strong> (Optional) Koi note likhna ho to</li>
        </ul>

        <h3>Step 4: Save Karein</h3>
        <p>"Save" button dabayein. Naya khata ban gaya!</p>

        <h3>Tips</h3>
        <ul>
          <li>Naam short aur clear rakhein</li>
          <li>Opening balance sahi daalein - isse balance sahi rahega</li>
          <li>Bahut zyada khate mat banayein - 3-5 kaafi hain</li>
        </ul>
      `,
    },
    {
      slug: 'khata-edit-delete-karein',
      title: 'Khata Edit ya Delete Kaise Karein',
      summary: 'Khate mein changes karna ya hatana',
      content: `
        <h2>Khata Edit Karna</h2>
        <p>Agar khate ka naam ya koi detail change karni ho:</p>
        <ol>
          <li>Ledgers page pe jaayein</li>
          <li>Jis khate ko edit karna hai uspe click karein</li>
          <li>"Edit" button dabayein</li>
          <li>Changes karein</li>
          <li>"Save" karein</li>
        </ol>

        <h2>Khata Archive Karna</h2>
        <p>Agar koi khata ab use nahi karte lekin hisab rakhna chahte hain:</p>
        <ul>
          <li>Khate pe click karein</li>
          <li>"Archive" option choose karein</li>
          <li>Khata list se hat jaayega lekin data safe rahega</li>
        </ul>

        <h2>Khata Delete Karna</h2>
        <p><strong>Dhyan se!</strong> Delete karne se saara data mit jaata hai.</p>
        <ol>
          <li>Khate pe click karein</li>
          <li>"Delete" button dabayein</li>
          <li>Confirm karein</li>
        </ol>
        <p><strong>Tip:</strong> Delete ki jagah Archive karna better hai - data safe rahega.</p>
      `,
    },
  ],
  'transactions': [
    {
      slug: 'transaction-kya-hai',
      title: 'Transaction Kya Hota Hai?',
      summary: 'Income, expense aur entries ka matlab',
      content: `
        <h2>Simple Bhasha Mein</h2>
        <p>Transaction matlab paison ka aana ya jaana. Jab bhi:</p>
        <ul>
          <li>Paisa aaye - yeh <strong>Income</strong> hai</li>
          <li>Paisa jaaye - yeh <strong>Expense</strong> hai</li>
        </ul>

        <h3>Example</h3>
        <ul>
          <li>Salary aayi ₹50,000 - yeh Income hai</li>
          <li>Grocery ka bill ₹2,000 - yeh Expense hai</li>
          <li>Kisi ne paisa lautaya ₹500 - yeh Income hai</li>
          <li>Bijli ka bill bhara ₹1,200 - yeh Expense hai</li>
        </ul>

        <h3>Kyun Record Karein?</h3>
        <p>Jab aap har transaction note karte hain:</p>
        <ul>
          <li>Pata rahega paisa kahaan gaya</li>
          <li>Month end pe report dekh sakte hain</li>
          <li>Budget plan kar sakte hain</li>
          <li>Faltu kharcha pakad sakte hain</li>
        </ul>

        <h3>Habit Banayein</h3>
        <p>Roz 2 minute lagake entries daalein. Isse hisab hamesha sahi rahega.</p>
      `,
    },
    {
      slug: 'income-kaise-add-karein',
      title: 'Income Kaise Add Karein',
      summary: 'Paisa aaya - kaise note karein',
      content: `
        <h2>Income Add Karna</h2>
        <p>Jab bhi paisa aaye - salary, bonus, kisi ne diya - income add karein.</p>

        <h3>Steps</h3>
        <ol>
          <li><strong>"+" button</strong> dabayein (screen ke neeche)</li>
          <li><strong>Type:</strong> "Income" choose karein</li>
          <li><strong>Amount:</strong> Kitna paisa aaya</li>
          <li><strong>Category:</strong> Salary? Gift? Business? Choose karein</li>
          <li><strong>Ledger:</strong> Kis khate mein aaya (Cash? Bank?)</li>
          <li><strong>Note:</strong> (Optional) Koi detail likhni ho</li>
          <li><strong>Save</strong> karein</li>
        </ol>

        <h3>Common Income Types</h3>
        <ul>
          <li>Salary / Tankhwah</li>
          <li>Business se kamai</li>
          <li>Interest (bank se)</li>
          <li>Kisi ne paisa lautaya</li>
          <li>Gift mila</li>
          <li>Freelance kaam se</li>
        </ul>

        <h3>Tip</h3>
        <p>Income aate hi turant add karein - baad mein bhool jaate hain!</p>
      `,
    },
    {
      slug: 'expense-kaise-add-karein',
      title: 'Expense Kaise Add Karein',
      summary: 'Paisa gaya - kaise note karein',
      content: `
        <h2>Expense Add Karna</h2>
        <p>Jab bhi paisa kharch ho - chhota ho ya bada - note karein.</p>

        <h3>Steps</h3>
        <ol>
          <li><strong>"+" button</strong> dabayein</li>
          <li><strong>Type:</strong> "Expense" choose karein</li>
          <li><strong>Amount:</strong> Kitna kharch hua</li>
          <li><strong>Category:</strong> Food? Transport? Shopping? Choose karein</li>
          <li><strong>Ledger:</strong> Kahan se diya (Cash? Card?)</li>
          <li><strong>Note:</strong> (Optional) Kya liya likhein</li>
          <li><strong>Save</strong> karein</li>
        </ol>

        <h3>Common Expense Categories</h3>
        <ul>
          <li>Khaana / Grocery</li>
          <li>Transport (petrol, auto, metro)</li>
          <li>Bills (bijli, phone, internet)</li>
          <li>Shopping</li>
          <li>Medical</li>
          <li>Entertainment</li>
        </ul>

        <h3>Chhota Kharcha Bhi Likhein</h3>
        <p>₹10 ki chai bhi note karein. Chhote kharche jodke bade ho jaate hain!</p>
      `,
    },
    {
      slug: 'udhari-kaise-manage-karein',
      title: 'Udhari (Dena-Lena) Kaise Manage Karein',
      summary: 'Kisi ko paisa diya ya liya - kaise track karein',
      content: `
        <h2>Udhari Kya Hai?</h2>
        <p>Jab aap kisi ko paisa dete hain ya kisi se lete hain - yeh udhari hai.</p>
        <ul>
          <li><strong>Dena hai (Receivable):</strong> Aapne kisi ko diya, wapas aana hai</li>
          <li><strong>Lena hai (Payable):</strong> Kisi ne aapko diya, aapko dena hai</li>
        </ul>

        <h3>Udhari Kaise Add Karein</h3>
        <ol>
          <li>"+" button dabayein</li>
          <li>Type mein "Receivable" (dena hai) ya "Payable" (lena hai) choose karein</li>
          <li>Amount daalein</li>
          <li>Note mein naam likhein - "Rahul ko diya" ya "Sharma ji se liya"</li>
          <li>Save karein</li>
        </ol>

        <h3>Jab Paisa Wapas Mile/Dein</h3>
        <p>Jab udhari clear ho jaaye, us entry ko mark karein ya naya entry daalein.</p>

        <h3>Kyun Track Karein?</h3>
        <ul>
          <li>Bhoolenge nahi kisne kitna dena hai</li>
          <li>Rishte mein gadbad nahi hogi</li>
          <li>Apna actual balance pata rahega</li>
        </ul>

        <h3>Tip</h3>
        <p>Udhari dete waqt hi app mein note karein - baad mein yaad nahi rahta.</p>
      `,
    },
  ],
  'vendors': [
    {
      slug: 'vendor-kya-hota-hai',
      title: 'Vendor/Dukandaar Kya Hota Hai?',
      summary: 'Vendor feature kyun use karein',
      content: `
        <h2>Vendor Matlab?</h2>
        <p>Vendor matlab woh log ya dukaan jinse aap regular khareedari karte hain aur jinka hisab rakhna hai.</p>

        <h3>Examples</h3>
        <ul>
          <li>Kirana wala - har mahine ka saamaan</li>
          <li>Doodh wala - roz ka doodh</li>
          <li>Sabzi wala - weekly sabzi</li>
          <li>Electrician - kabhi kabhi kaam</li>
          <li>Landlord - monthly rent</li>
        </ul>

        <h3>Kyun Use Karein?</h3>
        <p>Vendor feature se:</p>
        <ul>
          <li>Har dukandaar ka alag hisab rahega</li>
          <li>Kitna dena hai, kitna diya - clear rahega</li>
          <li>Month end pe pata rahega sabko kitna dena hai</li>
          <li>Payment history dekh sakte hain</li>
        </ul>

        <h3>Kab Use Karein?</h3>
        <p>Jab kisi dukandaar se udhaar lena padta ho ya monthly hisab rakhna ho - tab vendor add karein.</p>
      `,
    },
    {
      slug: 'vendor-ka-hisab-rakhein',
      title: 'Vendor Ka Hisab Kaise Rakhein',
      summary: 'Dukandaar add karna aur payment track karna',
      content: `
        <h2>Naya Vendor Add Karna</h2>
        <ol>
          <li>Menu mein "Vendors" pe jaayein</li>
          <li>"Add Vendor" dabayein</li>
          <li>Naam daalein (jaise "Sharma Kirana Store")</li>
          <li>Phone number (optional) - baad mein kaam aayega</li>
          <li>Save karein</li>
        </ol>

        <h2>Vendor Se Udhaar Lena</h2>
        <p>Jab dukandaar se saamaan lo aur baad mein payment karni ho:</p>
        <ol>
          <li>"+" button se naya entry</li>
          <li>Type: Payable (dena hai)</li>
          <li>Vendor select karein</li>
          <li>Amount daalein</li>
          <li>Save karein</li>
        </ol>

        <h2>Payment Karna</h2>
        <p>Jab vendor ko paisa dein:</p>
        <ol>
          <li>Vendor select karein</li>
          <li>"Make Payment" ya payment add karein</li>
          <li>Amount daalein</li>
          <li>Save karein</li>
        </ol>
        <p>App automatically calculate kar lega kitna baaki hai.</p>

        <h3>Tip</h3>
        <p>Har baar saamaan lo tab entry daalein. Month end pe tension nahi hogi!</p>
      `,
    },
  ],
  'budgets': [
    {
      slug: 'budget-kya-hota-hai',
      title: 'Budget Kya Hota Hai?',
      summary: 'Budget ka matlab aur kyun zaroori hai',
      content: `
        <h2>Simple Shabdon Mein</h2>
        <p>Budget matlab pehle se decide karna ki kitna kharcha karna hai.</p>

        <p>Jaise:</p>
        <ul>
          <li>"Is mahine grocery pe ₹5000 se zyada nahi kharcha karunga"</li>
          <li>"Entertainment pe ₹2000 tak hi"</li>
          <li>"Shopping pe ₹3000 limit"</li>
        </ul>

        <h3>Budget Kyun Banayein?</h3>
        <ul>
          <li><strong>Control:</strong> Faltu kharcha ruk jaata hai</li>
          <li><strong>Savings:</strong> Paisa bach jaata hai</li>
          <li><strong>Peace of mind:</strong> Tension nahi rahti ki paisa kahaan gaya</li>
          <li><strong>Goals:</strong> Kuch bada khareedne ke liye save kar sakte hain</li>
        </ul>

        <h3>Kaise Kaam Karta Hai?</h3>
        <p>Aap budget set karte hain. Jab kharcha karte hain, app track karta hai. Jab limit ke paas pahunchte hain, app bata deta hai.</p>

        <h3>Shuru Mein</h3>
        <p>Pehle 1-2 budget banayein jahan zyada kharcha hota hai. Baad mein aur add kar sakte hain.</p>
      `,
    },
    {
      slug: 'budget-kaise-banayein',
      title: 'Monthly Budget Kaise Set Karein',
      summary: 'Step by step budget banana',
      content: `
        <h2>Budget Banana</h2>

        <h3>Step 1: Budget Page Pe Jaayein</h3>
        <p>Menu mein "Budgets" pe click karein.</p>

        <h3>Step 2: Naya Budget Add Karein</h3>
        <p>"+ Add Budget" button dabayein.</p>

        <h3>Step 3: Details Bharein</h3>
        <ul>
          <li><strong>Name:</strong> Budget ka naam (jaise "Grocery Budget")</li>
          <li><strong>Category:</strong> Kis category ke liye (Food, Shopping, etc.)</li>
          <li><strong>Amount:</strong> Kitna kharcha allowed hai</li>
          <li><strong>Period:</strong> Monthly (har mahine reset)</li>
        </ul>

        <h3>Step 4: Save Karein</h3>
        <p>Save karte hi budget active ho jaayega.</p>

        <h2>Budget Track Karna</h2>
        <p>Budget page pe dikhega:</p>
        <ul>
          <li>Kitna kharcha ho chuka</li>
          <li>Kitna bacha hai</li>
          <li>Progress bar - green, yellow, ya red</li>
        </ul>

        <h3>Alert</h3>
        <p>Jab 80% budget use ho jaaye, app warning deta hai. Isse aap control kar sakte hain.</p>

        <h3>Tips</h3>
        <ul>
          <li>Realistic budget set karein - bahut tight mat rakhein</li>
          <li>Pehle month dekhein kitna kharcha hota hai, phir budget banayein</li>
          <li>Har category ka alag budget banana better hai</li>
        </ul>
      `,
    },
  ],
  'reports': [
    {
      slug: 'reports-kaise-dekhein',
      title: 'Reports Kaise Dekhein',
      summary: 'Apna paisa kahaan gaya - reports mein samjhein',
      content: `
        <h2>Reports Kyun Dekhein?</h2>
        <p>Reports se aapko pata chalta hai:</p>
        <ul>
          <li>Paisa kahaan zyada gaya</li>
          <li>Kitna kamaya, kitna kharch kiya</li>
          <li>Kaunsi category mein zyada kharcha hua</li>
          <li>Month by month comparison</li>
        </ul>

        <h3>Reports Page Pe Jaana</h3>
        <p>Menu mein "Reports" pe click karein.</p>

        <h3>Report Types</h3>

        <h4>1. Monthly Report</h4>
        <p>Is mahine ka poora summary:</p>
        <ul>
          <li>Total income</li>
          <li>Total expense</li>
          <li>Category-wise breakdown</li>
        </ul>

        <h4>2. Category Report</h4>
        <p>Har category mein kitna gaya - chart mein dekhein.</p>

        <h4>3. Yearly Overview</h4>
        <p>Poore saal ka hisab - month by month.</p>

        <h3>Kab Dekhein?</h3>
        <ul>
          <li>Month end pe - review ke liye</li>
          <li>Budget planning ke liye</li>
          <li>Jab lagey paisa bahut gaya - check karein kahaan</li>
        </ul>
      `,
    },
    {
      slug: 'spending-samjhein',
      title: 'Apna Kharcha Samjhein',
      summary: 'Category-wise kharcha analyze karein',
      content: `
        <h2>Kharcha Analyze Karna</h2>
        <p>Reports mein dekhein ki aapka paisa kahaan ja raha hai.</p>

        <h3>Category Breakdown</h3>
        <p>Pie chart ya list mein dekhein:</p>
        <ul>
          <li>Food mein kitna gaya</li>
          <li>Transport mein kitna</li>
          <li>Shopping mein kitna</li>
          <li>Bills mein kitna</li>
        </ul>

        <h3>Questions Poochhein Khud Se</h3>
        <ul>
          <li>Kya koi category mein bahut zyada gaya?</li>
          <li>Kya koi unnecessary kharcha hua?</li>
          <li>Kahan se cut kar sakte hain?</li>
        </ul>

        <h3>Action Lein</h3>
        <p>Agar kisi category mein zyada gaya:</p>
        <ol>
          <li>Us category ka budget set karein</li>
          <li>Agley mahine control karein</li>
          <li>Fir se report dekh ke compare karein</li>
        </ol>

        <h3>Monthly Habit</h3>
        <p>Har mahine 1st ya last date pe reports dekhein. 10 minute lagega, lekin bahut faayda hoga.</p>
      `,
    },
  ],
  'security': [
    {
      slug: 'password-safe-rakhein',
      title: 'Password Safe Kaise Rakhein',
      summary: 'Strong password tips aur account security',
      content: `
        <h2>Kyun Zaroori Hai?</h2>
        <p>Aapka financial data important hai. Strong password se account safe rahega.</p>

        <h3>Strong Password Kaise Banayein</h3>
        <ul>
          <li><strong>Lamba rakhein:</strong> Kam se kam 8 characters</li>
          <li><strong>Mix karein:</strong> Letters + numbers + special characters</li>
          <li><strong>Unique rakhein:</strong> Har app ke liye alag password</li>
        </ul>

        <h3>Yeh Mat Karein</h3>
        <ul>
          <li>Birthday mat rakhein (12345678)</li>
          <li>Naam mat rakhein (rahul123)</li>
          <li>Simple words mat rakhein (password, 123456)</li>
          <li>Kisi ko mat batayein</li>
        </ul>

        <h3>Password Change Karna</h3>
        <ol>
          <li>Settings mein jaayein</li>
          <li>"Change Password" pe click karein</li>
          <li>Purana password daalein</li>
          <li>Naya password daalein (2 baar)</li>
          <li>Save karein</li>
        </ol>

        <h3>Agar Bhool Gaye</h3>
        <p>Login page pe "Forgot Password" pe click karein. Email pe reset link aayega.</p>
      `,
    },
    {
      slug: 'logout-kyun-karein',
      title: 'Logout Karna Kyun Zaroori Hai',
      summary: 'Shared device pe safe rehna',
      content: `
        <h2>Logout Kyun Karein?</h2>
        <p>Agar aap kisi aur ka phone/computer use kar rahe hain, ya shared device hai, to logout karna zaroori hai.</p>

        <h3>Risk Kya Hai?</h3>
        <p>Agar logout nahi kiya:</p>
        <ul>
          <li>Koi aur aapka data dekh sakta hai</li>
          <li>Galti se koi entry add/delete ho sakti hai</li>
          <li>Private financial info leak ho sakti hai</li>
        </ul>

        <h3>Kab Logout Karein</h3>
        <ul>
          <li>Dusre ka phone/laptop use karne ke baad</li>
          <li>Office computer pe</li>
          <li>Public computer pe (cyber cafe, library)</li>
          <li>Phone kisi ko dene se pehle</li>
        </ul>

        <h3>Logout Kaise Karein</h3>
        <ol>
          <li>Profile ya Settings mein jaayein</li>
          <li>"Logout" button dabayein</li>
          <li>Confirm karein</li>
        </ol>

        <h3>Apne Phone Pe?</h3>
        <p>Apne personal phone pe logout karna zaroori nahi, lekin phone lock zaroor rakhein.</p>
      `,
    },
  ],
  'plans-and-billing': [
    {
      slug: 'free-vs-pro',
      title: 'Free vs Pro - Kya Farak Hai?',
      summary: 'Free plan mein kya milta hai, Pro mein kya extra',
      content: `
        <h2>Free Plan</h2>
        <p>Free plan mein aapko milta hai:</p>
        <ul>
          <li>Unlimited transactions add karein</li>
          <li>3 ledgers (khate) bana sakte hain</li>
          <li>Basic categories</li>
          <li>Monthly reports</li>
          <li>Budget tracking</li>
          <li>Reminders</li>
        </ul>
        <p><strong>Free plan mein bhi bahut kuch kar sakte hain!</strong></p>

        <h2>Pro Plan</h2>
        <p>Pro plan mein extra milta hai:</p>
        <ul>
          <li>Unlimited ledgers</li>
          <li>Custom categories banayein</li>
          <li>Detailed reports aur charts</li>
          <li>Data export (Excel mein)</li>
          <li>Priority support</li>
          <li>Advanced budget features</li>
        </ul>

        <h3>Kisko Pro Lena Chahiye?</h3>
        <ul>
          <li>Business walon ko - multiple khate chahiye</li>
          <li>Jinhe detailed reports chahiye</li>
          <li>Jo data export karna chahte hain</li>
        </ul>

        <h3>Kisko Free Kaafi Hai?</h3>
        <ul>
          <li>Personal use ke liye</li>
          <li>Simple hisab kitab ke liye</li>
          <li>Shuru mein try karne ke liye</li>
        </ul>

        <h3>Pro Kaise Lein?</h3>
        <p>Settings > Plans mein jaake upgrade kar sakte hain.</p>
      `,
    },
  ],
};

/**
 * Get category by ID
 */
export function getCategoryById(categoryId) {
  return HELP_CATEGORIES.find(cat => cat.id === categoryId) || null;
}

/**
 * Get articles for a category
 */
export function getArticlesByCategory(categoryId) {
  return HELP_ARTICLES[categoryId] || [];
}

/**
 * Get single article by category and slug
 */
export function getArticleBySlug(categoryId, slug) {
  const articles = HELP_ARTICLES[categoryId] || [];
  return articles.find(article => article.slug === slug) || null;
}

/**
 * Get all articles (flat list)
 */
export function getAllArticles() {
  const all = [];
  Object.entries(HELP_ARTICLES).forEach(([categoryId, articles]) => {
    articles.forEach(article => {
      all.push({ ...article, categoryId });
    });
  });
  return all;
}
